import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Toolsrealestate() {
  return (
    <section className="tools_real_estate p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Tech Tools We Use in <span>Real Estate</span> Application
              Development
            </h2>
            <p>
              As a Top Real Estate App Development company, we excel in
              developing comprehensive applications using diverse modern
              frameworks and programming languages.
            </p>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="tool-tech-main">
              <div className="tools-item">
                <div className="tools-img">
                  <StaticImage
                    src="../../../images/solution/real-estate-updated/tools/kotlin.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                </div>
              </div>
              <div className="tools-item">
                <div className="tools-img">
                  <StaticImage
                    src="../../../images/solution/real-estate-updated/tools/React_Native.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                </div>
              </div>
              <div className="tools-item">
                <div className="tools-img">
                  <StaticImage
                    src="../../../images/solution/real-estate-updated/tools/Flutter.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                </div>
              </div>
              <div className="tools-item">
                <div className="tools-img">
                  <StaticImage
                    src="../../../images/solution/real-estate-updated/tools/Firebase.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                </div>
              </div>
              <div className="tools-item">
                <div className="tools-img">
                  <StaticImage
                    src="../../../images/solution/real-estate-updated/tools/Realm.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                </div>
              </div>
              <div className="tools-item">
                <div className="tools-img">
                  <StaticImage
                    src="../../../images/solution/real-estate-updated/tools/Java.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                </div>
              </div>
              <div className="tools-item">
                <div className="tools-img">
                  <StaticImage
                    src="../../../images/solution/real-estate-updated/tools/Room_Database.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                </div>
              </div>
              <div className="tools-item">
                <div className="tools-img">
                  <StaticImage
                    src="../../../images/solution/real-estate-updated/tools/Azure.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                </div>
              </div>
              <div className="tools-item">
                <div className="tools-img">
                  <StaticImage
                    src="../../../images/solution/real-estate-updated/tools/Magento.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                </div>
              </div>
              <div className="tools-item">
                <div className="tools-img">
                  <StaticImage
                    src="../../../images/solution/real-estate-updated/tools/Figma.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                </div>
              </div>
              <div className="tools-item">
                <div className="tools-img">
                  <StaticImage
                    src="../../../images/solution/real-estate-updated/tools/Python.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                </div>
              </div>
              <div className="tools-item">
                <div className="tools-img">
                  <StaticImage
                    src="../../../images/solution/real-estate-updated/tools/Fastlane.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                </div>
              </div>
              <div className="tools-item">
                <div className="tools-img">
                  <StaticImage
                    src="../../../images/solution/real-estate-updated/tools/SQL_Lite.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                </div>
              </div>
              <div className="tools-item">
                <div className="tools-img">
                  <StaticImage
                    src="../../../images/solution/real-estate-updated/tools/Swift.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                </div>
              </div>
              <div className="tools-item">
                <div className="tools-img">
                  <StaticImage
                    src="../../../images/solution/real-estate-updated/tools/Symfony.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                </div>
              </div>
              <div className="tools-item">
                <div className="tools-img">
                  <StaticImage
                    src="../../../images/solution/real-estate-updated/tools/Ionic.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Toolsrealestate;
